/* eslint-disable */

// @ts-nocheck

// biome-ignore-all lint: generated by @tanstack/router-plugin

// biome-ignore-all assist/source/organizeImports: generated by @tanstack/router-plugin

// biome-ignore-all format: generated by @tanstack/router-plugin

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthenticatedRouteImport } from "./routes/_authenticated";
import { Route as CreateAccountRouteImport } from "./routes/create-account";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as SearchRouteImport } from "./routes/search";
import { Route as ViewportLabRouteImport } from "./routes/viewport-lab";
import { Route as AuthenticatedAgentsRouteImport } from "./routes/_authenticated/agents";
import { Route as AuthenticatedDeviceRouteImport } from "./routes/_authenticated/device";
import { Route as AuthenticatedEarningsRouteImport } from "./routes/_authenticated/earnings";
import { Route as AuthenticatedEvalsRouteImport } from "./routes/_authenticated/evals";
import { Route as AuthenticatedGamesRouteImport } from "./routes/_authenticated/games";
import { Route as AuthenticatedLedgerRouteImport } from "./routes/_authenticated/ledger";
import { Route as AuthenticatedModelsRouteImport } from "./routes/_authenticated/models";
import { Route as AuthenticatedModerationRouteImport } from "./routes/_authenticated/moderation";
import { Route as AuthenticatedStaffRouteImport } from "./routes/_authenticated/staff";
import { Route as AccountDeletedRouteImport } from "./routes/account.deleted";
import { Route as AssetsIndexRouteImport } from "./routes/assets.index";
import { Route as CheckoutAppReturnRouteImport } from "./routes/checkout.app-return";
import { Route as ProfilesProfileIdRouteImport } from "./routes/profiles.$profileId";
import { Route as AuthenticatedAccountDeletionRouteImport } from "./routes/_authenticated/account.deletion";
import { Route as AuthenticatedAssetsMineRouteImport } from "./routes/_authenticated/assets.mine";
import { Route as AuthenticatedPlayGameIdRouteImport } from "./routes/_authenticated/play.$gameId";
import { Route as AssetsAssetIdIndexRouteImport } from "./routes/assets.$assetId.index";
import { Route as AssetsCollectionsIndexRouteImport } from "./routes/assets.collections.index";
import { Route as AssetsCollectionsCollectionIdRouteImport } from "./routes/assets.collections.$collectionId";
import { Route as PresetsSlugIndexRouteImport } from "./routes/presets.$slug.index";
import { Route as PresetsSlugStillRouteImport } from "./routes/presets.$slug.still";
import { Route as AuthenticatedAssetsCollectionsMineRouteImport } from "./routes/_authenticated/assets.collections.mine";
import { Route as AuthenticatedPlayGameIdDebugRouteImport } from "./routes/_authenticated/play_.$gameId.debug";
import { Route as AuthenticatedPresetsSlugEditRouteImport } from "./routes/_authenticated/presets.$slug.edit";
import { Route as AuthenticatedPresetsSlugNewRouteImport } from "./routes/_authenticated/presets.$slug.new";
import { Route as AssetsKindSlugIndexRouteImport } from "./routes/assets.$kind.$slug.index";
import { Route as AuthenticatedAssetsIdAssetIdEditRouteImport } from "./routes/_authenticated/assets.id.$assetId.edit";
import { Route as AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport } from "./routes/_authenticated/assets.id.$assetId.drafts.$versionId";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRouteImport,
} as any);
const CreateAccountRoute = CreateAccountRouteImport.update({
  id: "/create-account",
  path: "/create-account",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const SearchRoute = SearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => rootRouteImport,
} as any);
const ViewportLabRoute = ViewportLabRouteImport.update({
  id: "/viewport-lab",
  path: "/viewport-lab",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAgentsRoute = AuthenticatedAgentsRouteImport.update({
  id: "/agents",
  path: "/agents",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedDeviceRoute = AuthenticatedDeviceRouteImport.update({
  id: "/device",
  path: "/device",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEarningsRoute = AuthenticatedEarningsRouteImport.update({
  id: "/earnings",
  path: "/earnings",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedEvalsRoute = AuthenticatedEvalsRouteImport.update({
  id: "/evals",
  path: "/evals",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedGamesRoute = AuthenticatedGamesRouteImport.update({
  id: "/games",
  path: "/games",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedLedgerRoute = AuthenticatedLedgerRouteImport.update({
  id: "/ledger",
  path: "/ledger",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedModelsRoute = AuthenticatedModelsRouteImport.update({
  id: "/models",
  path: "/models",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedModerationRoute = AuthenticatedModerationRouteImport.update({
  id: "/moderation",
  path: "/moderation",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedStaffRoute = AuthenticatedStaffRouteImport.update({
  id: "/staff",
  path: "/staff",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AccountDeletedRoute = AccountDeletedRouteImport.update({
  id: "/account/deleted",
  path: "/account/deleted",
  getParentRoute: () => rootRouteImport,
} as any);
const AssetsIndexRoute = AssetsIndexRouteImport.update({
  id: "/assets/",
  path: "/assets/",
  getParentRoute: () => rootRouteImport,
} as any);
const CheckoutAppReturnRoute = CheckoutAppReturnRouteImport.update({
  id: "/checkout/app-return",
  path: "/checkout/app-return",
  getParentRoute: () => rootRouteImport,
} as any);
const ProfilesProfileIdRoute = ProfilesProfileIdRouteImport.update({
  id: "/profiles/$profileId",
  path: "/profiles/$profileId",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAccountDeletionRoute =
  AuthenticatedAccountDeletionRouteImport.update({
    id: "/account/deletion",
    path: "/account/deletion",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsMineRoute = AuthenticatedAssetsMineRouteImport.update({
  id: "/assets/mine",
  path: "/assets/mine",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedPlayGameIdRoute = AuthenticatedPlayGameIdRouteImport.update({
  id: "/play/$gameId",
  path: "/play/$gameId",
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AssetsAssetIdIndexRoute = AssetsAssetIdIndexRouteImport.update({
  id: "/assets/$assetId/",
  path: "/assets/$assetId/",
  getParentRoute: () => rootRouteImport,
} as any);
const AssetsCollectionsIndexRoute = AssetsCollectionsIndexRouteImport.update({
  id: "/assets/collections/",
  path: "/assets/collections/",
  getParentRoute: () => rootRouteImport,
} as any);
const AssetsCollectionsCollectionIdRoute =
  AssetsCollectionsCollectionIdRouteImport.update({
    id: "/assets/collections/$collectionId",
    path: "/assets/collections/$collectionId",
    getParentRoute: () => rootRouteImport,
  } as any);
const PresetsSlugIndexRoute = PresetsSlugIndexRouteImport.update({
  id: "/presets/$slug/",
  path: "/presets/$slug/",
  getParentRoute: () => rootRouteImport,
} as any);
const PresetsSlugStillRoute = PresetsSlugStillRouteImport.update({
  id: "/presets/$slug/still",
  path: "/presets/$slug/still",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAssetsCollectionsMineRoute =
  AuthenticatedAssetsCollectionsMineRouteImport.update({
    id: "/assets/collections/mine",
    path: "/assets/collections/mine",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPlayGameIdDebugRoute =
  AuthenticatedPlayGameIdDebugRouteImport.update({
    id: "/play_/$gameId/debug",
    path: "/play/$gameId/debug",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugEditRoute =
  AuthenticatedPresetsSlugEditRouteImport.update({
    id: "/presets/$slug/edit",
    path: "/presets/$slug/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedPresetsSlugNewRoute =
  AuthenticatedPresetsSlugNewRouteImport.update({
    id: "/presets/$slug/new",
    path: "/presets/$slug/new",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AssetsKindSlugIndexRoute = AssetsKindSlugIndexRouteImport.update({
  id: "/assets/$kind/$slug/",
  path: "/assets/$kind/$slug/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedAssetsIdAssetIdEditRoute =
  AuthenticatedAssetsIdAssetIdEditRouteImport.update({
    id: "/assets/id/$assetId/edit",
    path: "/assets/id/$assetId/edit",
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute =
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport.update({
    id: "/assets/id/$assetId/drafts/$versionId",
    path: "/assets/id/$assetId/drafts/$versionId",
    getParentRoute: () => AuthenticatedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/search": typeof SearchRoute;
  "/viewport-lab": typeof ViewportLabRoute;
  "/agents": typeof AuthenticatedAgentsRoute;
  "/device": typeof AuthenticatedDeviceRoute;
  "/earnings": typeof AuthenticatedEarningsRoute;
  "/evals": typeof AuthenticatedEvalsRoute;
  "/games": typeof AuthenticatedGamesRoute;
  "/ledger": typeof AuthenticatedLedgerRoute;
  "/models": typeof AuthenticatedModelsRoute;
  "/moderation": typeof AuthenticatedModerationRoute;
  "/staff": typeof AuthenticatedStaffRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/profiles/$profileId": typeof ProfilesProfileIdRoute;
  "/assets/": typeof AssetsIndexRoute;
  "/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/assets/collections/$collectionId": typeof AssetsCollectionsCollectionIdRoute;
  "/presets/$slug/still": typeof PresetsSlugStillRoute;
  "/assets/$assetId/": typeof AssetsAssetIdIndexRoute;
  "/assets/collections/": typeof AssetsCollectionsIndexRoute;
  "/presets/$slug/": typeof PresetsSlugIndexRoute;
  "/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/play/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/assets/$kind/$slug/": typeof AssetsKindSlugIndexRoute;
  "/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/search": typeof SearchRoute;
  "/viewport-lab": typeof ViewportLabRoute;
  "/agents": typeof AuthenticatedAgentsRoute;
  "/device": typeof AuthenticatedDeviceRoute;
  "/earnings": typeof AuthenticatedEarningsRoute;
  "/evals": typeof AuthenticatedEvalsRoute;
  "/games": typeof AuthenticatedGamesRoute;
  "/ledger": typeof AuthenticatedLedgerRoute;
  "/models": typeof AuthenticatedModelsRoute;
  "/moderation": typeof AuthenticatedModerationRoute;
  "/staff": typeof AuthenticatedStaffRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/profiles/$profileId": typeof ProfilesProfileIdRoute;
  "/assets": typeof AssetsIndexRoute;
  "/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/assets/collections/$collectionId": typeof AssetsCollectionsCollectionIdRoute;
  "/presets/$slug/still": typeof PresetsSlugStillRoute;
  "/assets/$assetId": typeof AssetsAssetIdIndexRoute;
  "/assets/collections": typeof AssetsCollectionsIndexRoute;
  "/presets/$slug": typeof PresetsSlugIndexRoute;
  "/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/play/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/assets/$kind/$slug": typeof AssetsKindSlugIndexRoute;
  "/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/create-account": typeof CreateAccountRoute;
  "/login": typeof LoginRoute;
  "/search": typeof SearchRoute;
  "/viewport-lab": typeof ViewportLabRoute;
  "/_authenticated/agents": typeof AuthenticatedAgentsRoute;
  "/_authenticated/device": typeof AuthenticatedDeviceRoute;
  "/_authenticated/earnings": typeof AuthenticatedEarningsRoute;
  "/_authenticated/evals": typeof AuthenticatedEvalsRoute;
  "/_authenticated/games": typeof AuthenticatedGamesRoute;
  "/_authenticated/ledger": typeof AuthenticatedLedgerRoute;
  "/_authenticated/models": typeof AuthenticatedModelsRoute;
  "/_authenticated/moderation": typeof AuthenticatedModerationRoute;
  "/_authenticated/staff": typeof AuthenticatedStaffRoute;
  "/account/deleted": typeof AccountDeletedRoute;
  "/checkout/app-return": typeof CheckoutAppReturnRoute;
  "/profiles/$profileId": typeof ProfilesProfileIdRoute;
  "/assets/": typeof AssetsIndexRoute;
  "/_authenticated/account/deletion": typeof AuthenticatedAccountDeletionRoute;
  "/_authenticated/assets/mine": typeof AuthenticatedAssetsMineRoute;
  "/_authenticated/play/$gameId": typeof AuthenticatedPlayGameIdRoute;
  "/assets/collections/$collectionId": typeof AssetsCollectionsCollectionIdRoute;
  "/presets/$slug/still": typeof PresetsSlugStillRoute;
  "/assets/$assetId/": typeof AssetsAssetIdIndexRoute;
  "/assets/collections/": typeof AssetsCollectionsIndexRoute;
  "/presets/$slug/": typeof PresetsSlugIndexRoute;
  "/_authenticated/assets/collections/mine": typeof AuthenticatedAssetsCollectionsMineRoute;
  "/_authenticated/play_/$gameId/debug": typeof AuthenticatedPlayGameIdDebugRoute;
  "/_authenticated/presets/$slug/edit": typeof AuthenticatedPresetsSlugEditRoute;
  "/_authenticated/presets/$slug/new": typeof AuthenticatedPresetsSlugNewRoute;
  "/assets/$kind/$slug/": typeof AssetsKindSlugIndexRoute;
  "/_authenticated/assets/id/$assetId/edit": typeof AuthenticatedAssetsIdAssetIdEditRoute;
  "/_authenticated/assets/id/$assetId/drafts/$versionId": typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/create-account"
    | "/login"
    | "/search"
    | "/viewport-lab"
    | "/agents"
    | "/device"
    | "/earnings"
    | "/evals"
    | "/games"
    | "/ledger"
    | "/models"
    | "/moderation"
    | "/staff"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/profiles/$profileId"
    | "/assets/"
    | "/account/deletion"
    | "/assets/mine"
    | "/play/$gameId"
    | "/assets/collections/$collectionId"
    | "/presets/$slug/still"
    | "/assets/$assetId/"
    | "/assets/collections/"
    | "/presets/$slug/"
    | "/assets/collections/mine"
    | "/play/$gameId/debug"
    | "/presets/$slug/edit"
    | "/presets/$slug/new"
    | "/assets/$kind/$slug/"
    | "/assets/id/$assetId/edit"
    | "/assets/id/$assetId/drafts/$versionId";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/create-account"
    | "/login"
    | "/search"
    | "/viewport-lab"
    | "/agents"
    | "/device"
    | "/earnings"
    | "/evals"
    | "/games"
    | "/ledger"
    | "/models"
    | "/moderation"
    | "/staff"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/profiles/$profileId"
    | "/assets"
    | "/account/deletion"
    | "/assets/mine"
    | "/play/$gameId"
    | "/assets/collections/$collectionId"
    | "/presets/$slug/still"
    | "/assets/$assetId"
    | "/assets/collections"
    | "/presets/$slug"
    | "/assets/collections/mine"
    | "/play/$gameId/debug"
    | "/presets/$slug/edit"
    | "/presets/$slug/new"
    | "/assets/$kind/$slug"
    | "/assets/id/$assetId/edit"
    | "/assets/id/$assetId/drafts/$versionId";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/create-account"
    | "/login"
    | "/search"
    | "/viewport-lab"
    | "/_authenticated/agents"
    | "/_authenticated/device"
    | "/_authenticated/earnings"
    | "/_authenticated/evals"
    | "/_authenticated/games"
    | "/_authenticated/ledger"
    | "/_authenticated/models"
    | "/_authenticated/moderation"
    | "/_authenticated/staff"
    | "/account/deleted"
    | "/checkout/app-return"
    | "/profiles/$profileId"
    | "/assets/"
    | "/_authenticated/account/deletion"
    | "/_authenticated/assets/mine"
    | "/_authenticated/play/$gameId"
    | "/assets/collections/$collectionId"
    | "/presets/$slug/still"
    | "/assets/$assetId/"
    | "/assets/collections/"
    | "/presets/$slug/"
    | "/_authenticated/assets/collections/mine"
    | "/_authenticated/play_/$gameId/debug"
    | "/_authenticated/presets/$slug/edit"
    | "/_authenticated/presets/$slug/new"
    | "/assets/$kind/$slug/"
    | "/_authenticated/assets/id/$assetId/edit"
    | "/_authenticated/assets/id/$assetId/drafts/$versionId";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  CreateAccountRoute: typeof CreateAccountRoute;
  LoginRoute: typeof LoginRoute;
  SearchRoute: typeof SearchRoute;
  ViewportLabRoute: typeof ViewportLabRoute;
  AccountDeletedRoute: typeof AccountDeletedRoute;
  CheckoutAppReturnRoute: typeof CheckoutAppReturnRoute;
  ProfilesProfileIdRoute: typeof ProfilesProfileIdRoute;
  AssetsIndexRoute: typeof AssetsIndexRoute;
  AssetsCollectionsCollectionIdRoute: typeof AssetsCollectionsCollectionIdRoute;
  PresetsSlugStillRoute: typeof PresetsSlugStillRoute;
  AssetsAssetIdIndexRoute: typeof AssetsAssetIdIndexRoute;
  AssetsCollectionsIndexRoute: typeof AssetsCollectionsIndexRoute;
  PresetsSlugIndexRoute: typeof PresetsSlugIndexRoute;
  AssetsKindSlugIndexRoute: typeof AssetsKindSlugIndexRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/create-account": {
      id: "/create-account";
      path: "/create-account";
      fullPath: "/create-account";
      preLoaderRoute: typeof CreateAccountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/search": {
      id: "/search";
      path: "/search";
      fullPath: "/search";
      preLoaderRoute: typeof SearchRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/viewport-lab": {
      id: "/viewport-lab";
      path: "/viewport-lab";
      fullPath: "/viewport-lab";
      preLoaderRoute: typeof ViewportLabRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/agents": {
      id: "/_authenticated/agents";
      path: "/agents";
      fullPath: "/agents";
      preLoaderRoute: typeof AuthenticatedAgentsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/device": {
      id: "/_authenticated/device";
      path: "/device";
      fullPath: "/device";
      preLoaderRoute: typeof AuthenticatedDeviceRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/earnings": {
      id: "/_authenticated/earnings";
      path: "/earnings";
      fullPath: "/earnings";
      preLoaderRoute: typeof AuthenticatedEarningsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/evals": {
      id: "/_authenticated/evals";
      path: "/evals";
      fullPath: "/evals";
      preLoaderRoute: typeof AuthenticatedEvalsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/games": {
      id: "/_authenticated/games";
      path: "/games";
      fullPath: "/games";
      preLoaderRoute: typeof AuthenticatedGamesRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/ledger": {
      id: "/_authenticated/ledger";
      path: "/ledger";
      fullPath: "/ledger";
      preLoaderRoute: typeof AuthenticatedLedgerRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/models": {
      id: "/_authenticated/models";
      path: "/models";
      fullPath: "/models";
      preLoaderRoute: typeof AuthenticatedModelsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/moderation": {
      id: "/_authenticated/moderation";
      path: "/moderation";
      fullPath: "/moderation";
      preLoaderRoute: typeof AuthenticatedModerationRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/staff": {
      id: "/_authenticated/staff";
      path: "/staff";
      fullPath: "/staff";
      preLoaderRoute: typeof AuthenticatedStaffRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/account/deleted": {
      id: "/account/deleted";
      path: "/account/deleted";
      fullPath: "/account/deleted";
      preLoaderRoute: typeof AccountDeletedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/assets/": {
      id: "/assets/";
      path: "/assets";
      fullPath: "/assets/";
      preLoaderRoute: typeof AssetsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/checkout/app-return": {
      id: "/checkout/app-return";
      path: "/checkout/app-return";
      fullPath: "/checkout/app-return";
      preLoaderRoute: typeof CheckoutAppReturnRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/profiles/$profileId": {
      id: "/profiles/$profileId";
      path: "/profiles/$profileId";
      fullPath: "/profiles/$profileId";
      preLoaderRoute: typeof ProfilesProfileIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/account/deletion": {
      id: "/_authenticated/account/deletion";
      path: "/account/deletion";
      fullPath: "/account/deletion";
      preLoaderRoute: typeof AuthenticatedAccountDeletionRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/mine": {
      id: "/_authenticated/assets/mine";
      path: "/assets/mine";
      fullPath: "/assets/mine";
      preLoaderRoute: typeof AuthenticatedAssetsMineRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/play/$gameId": {
      id: "/_authenticated/play/$gameId";
      path: "/play/$gameId";
      fullPath: "/play/$gameId";
      preLoaderRoute: typeof AuthenticatedPlayGameIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/assets/$assetId/": {
      id: "/assets/$assetId/";
      path: "/assets/$assetId";
      fullPath: "/assets/$assetId/";
      preLoaderRoute: typeof AssetsAssetIdIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/assets/collections/": {
      id: "/assets/collections/";
      path: "/assets/collections";
      fullPath: "/assets/collections/";
      preLoaderRoute: typeof AssetsCollectionsIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/assets/collections/$collectionId": {
      id: "/assets/collections/$collectionId";
      path: "/assets/collections/$collectionId";
      fullPath: "/assets/collections/$collectionId";
      preLoaderRoute: typeof AssetsCollectionsCollectionIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/presets/$slug/": {
      id: "/presets/$slug/";
      path: "/presets/$slug";
      fullPath: "/presets/$slug/";
      preLoaderRoute: typeof PresetsSlugIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/presets/$slug/still": {
      id: "/presets/$slug/still";
      path: "/presets/$slug/still";
      fullPath: "/presets/$slug/still";
      preLoaderRoute: typeof PresetsSlugStillRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/assets/collections/mine": {
      id: "/_authenticated/assets/collections/mine";
      path: "/assets/collections/mine";
      fullPath: "/assets/collections/mine";
      preLoaderRoute: typeof AuthenticatedAssetsCollectionsMineRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/play_/$gameId/debug": {
      id: "/_authenticated/play_/$gameId/debug";
      path: "/play/$gameId/debug";
      fullPath: "/play/$gameId/debug";
      preLoaderRoute: typeof AuthenticatedPlayGameIdDebugRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/edit": {
      id: "/_authenticated/presets/$slug/edit";
      path: "/presets/$slug/edit";
      fullPath: "/presets/$slug/edit";
      preLoaderRoute: typeof AuthenticatedPresetsSlugEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/presets/$slug/new": {
      id: "/_authenticated/presets/$slug/new";
      path: "/presets/$slug/new";
      fullPath: "/presets/$slug/new";
      preLoaderRoute: typeof AuthenticatedPresetsSlugNewRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/assets/$kind/$slug/": {
      id: "/assets/$kind/$slug/";
      path: "/assets/$kind/$slug";
      fullPath: "/assets/$kind/$slug/";
      preLoaderRoute: typeof AssetsKindSlugIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authenticated/assets/id/$assetId/edit": {
      id: "/_authenticated/assets/id/$assetId/edit";
      path: "/assets/id/$assetId/edit";
      fullPath: "/assets/id/$assetId/edit";
      preLoaderRoute: typeof AuthenticatedAssetsIdAssetIdEditRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    "/_authenticated/assets/id/$assetId/drafts/$versionId": {
      id: "/_authenticated/assets/id/$assetId/drafts/$versionId";
      path: "/assets/id/$assetId/drafts/$versionId";
      fullPath: "/assets/id/$assetId/drafts/$versionId";
      preLoaderRoute: typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedAgentsRoute: typeof AuthenticatedAgentsRoute;
  AuthenticatedDeviceRoute: typeof AuthenticatedDeviceRoute;
  AuthenticatedEarningsRoute: typeof AuthenticatedEarningsRoute;
  AuthenticatedEvalsRoute: typeof AuthenticatedEvalsRoute;
  AuthenticatedGamesRoute: typeof AuthenticatedGamesRoute;
  AuthenticatedLedgerRoute: typeof AuthenticatedLedgerRoute;
  AuthenticatedModelsRoute: typeof AuthenticatedModelsRoute;
  AuthenticatedModerationRoute: typeof AuthenticatedModerationRoute;
  AuthenticatedStaffRoute: typeof AuthenticatedStaffRoute;
  AuthenticatedAccountDeletionRoute: typeof AuthenticatedAccountDeletionRoute;
  AuthenticatedAssetsMineRoute: typeof AuthenticatedAssetsMineRoute;
  AuthenticatedPlayGameIdRoute: typeof AuthenticatedPlayGameIdRoute;
  AuthenticatedAssetsCollectionsMineRoute: typeof AuthenticatedAssetsCollectionsMineRoute;
  AuthenticatedPlayGameIdDebugRoute: typeof AuthenticatedPlayGameIdDebugRoute;
  AuthenticatedPresetsSlugEditRoute: typeof AuthenticatedPresetsSlugEditRoute;
  AuthenticatedPresetsSlugNewRoute: typeof AuthenticatedPresetsSlugNewRoute;
  AuthenticatedAssetsIdAssetIdEditRoute: typeof AuthenticatedAssetsIdAssetIdEditRoute;
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute: typeof AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAgentsRoute: AuthenticatedAgentsRoute,
  AuthenticatedDeviceRoute: AuthenticatedDeviceRoute,
  AuthenticatedEarningsRoute: AuthenticatedEarningsRoute,
  AuthenticatedEvalsRoute: AuthenticatedEvalsRoute,
  AuthenticatedGamesRoute: AuthenticatedGamesRoute,
  AuthenticatedLedgerRoute: AuthenticatedLedgerRoute,
  AuthenticatedModelsRoute: AuthenticatedModelsRoute,
  AuthenticatedModerationRoute: AuthenticatedModerationRoute,
  AuthenticatedStaffRoute: AuthenticatedStaffRoute,
  AuthenticatedAccountDeletionRoute: AuthenticatedAccountDeletionRoute,
  AuthenticatedAssetsMineRoute: AuthenticatedAssetsMineRoute,
  AuthenticatedPlayGameIdRoute: AuthenticatedPlayGameIdRoute,
  AuthenticatedAssetsCollectionsMineRoute:
    AuthenticatedAssetsCollectionsMineRoute,
  AuthenticatedPlayGameIdDebugRoute: AuthenticatedPlayGameIdDebugRoute,
  AuthenticatedPresetsSlugEditRoute: AuthenticatedPresetsSlugEditRoute,
  AuthenticatedPresetsSlugNewRoute: AuthenticatedPresetsSlugNewRoute,
  AuthenticatedAssetsIdAssetIdEditRoute: AuthenticatedAssetsIdAssetIdEditRoute,
  AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute:
    AuthenticatedAssetsIdAssetIdDraftsVersionIdRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  CreateAccountRoute: CreateAccountRoute,
  LoginRoute: LoginRoute,
  SearchRoute: SearchRoute,
  ViewportLabRoute: ViewportLabRoute,
  AccountDeletedRoute: AccountDeletedRoute,
  CheckoutAppReturnRoute: CheckoutAppReturnRoute,
  ProfilesProfileIdRoute: ProfilesProfileIdRoute,
  AssetsIndexRoute: AssetsIndexRoute,
  AssetsCollectionsCollectionIdRoute: AssetsCollectionsCollectionIdRoute,
  PresetsSlugStillRoute: PresetsSlugStillRoute,
  AssetsAssetIdIndexRoute: AssetsAssetIdIndexRoute,
  AssetsCollectionsIndexRoute: AssetsCollectionsIndexRoute,
  PresetsSlugIndexRoute: PresetsSlugIndexRoute,
  AssetsKindSlugIndexRoute: AssetsKindSlugIndexRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
